<svg *ngIf="linePath" class="cc-chart" [attr.viewBox]="viewBox" [attr.role]="alertDots.length ? 'group' : 'img'" [attr.aria-label]="ariaLabel">
  <!-- The floor, and the line the Issue becomes Active on. -->
  <line class="cc-axis" [attr.x1]="plotLeft" [attr.x2]="plotRight"
        [attr.y1]="plotBottom" [attr.y2]="plotBottom"></line>
  <line class="cc-guide" [attr.x1]="plotLeft" [attr.x2]="plotRight"
        [attr.y1]="guideY" [attr.y2]="guideY"></line>
  <text class="cc-label" [attr.x]="plotLeft - 5" [attr.y]="plotTop + 4" text-anchor="end">100%</text>
  <text class="cc-label" [attr.x]="plotLeft - 5" [attr.y]="guideY + 3" text-anchor="end">50%</text>
  <text class="cc-label" [attr.x]="plotLeft - 5" [attr.y]="plotBottom" text-anchor="end">0%</text>
  <!-- Parked at the right edge: the line spends most of its life on the left, where a
       label would sit under it. -->
  <text class="cc-guide-label" [attr.x]="plotRight + 10" [attr.y]="guideY + 4" text-anchor="start">
    {{ '@issueChartActive' | translate }}</text>

  <path class="cc-line" [attr.d]="linePath"></path>

  <!-- A wide invisible copy of each aging run, so hovering the run says which way it
       went and over how many passes. The drawn line is too thin to be a target. -->
  <path *ngFor="let run of runs" class="cc-hit" [attr.d]="run.d"><title>{{ run.title }}</title></path>

  <circle *ngFor="let dot of (showDots ? dots : [])" class="cc-dot" [class.cc-dot-transition]="dot.kind === 'transition'"
          [attr.cx]="dot.cx" [attr.cy]="dot.cy" r="2.8"><title>{{ dot.title }}</title></circle>

  <g *ngFor="let dot of alertGroups" class="cc-alert-group" tabindex="0" role="img" [attr.aria-label]="dot.title">
    <title>{{ dot.title }}</title>
    <circle class="cc-alert-target" [attr.cx]="dot.cx" [attr.cy]="dot.cy" r="12" aria-hidden="true"></circle>
    <circle class="cc-dot cc-alert-marker" [attr.cx]="dot.cx" [attr.cy]="dot.cy"
            r="3.5" aria-hidden="true"></circle>

  </g>

  <!-- Severity, in the house tier colours. A step, never a slope: severity holds its
       value until a signal changes it. -->
  <rect *ngFor="let step of (showSeverity ? ribbon : [])" class="cc-sev"
        [attr.x]="step.x" [attr.y]="ribbonTop" [attr.width]="step.width"
        [attr.height]="ribbonHeight" [attr.fill]="step.fill"><title>{{ step.title }}</title></rect>

  <text *ngFor="let tick of xTicks" class="cc-label"
        [attr.x]="tick.x" [attr.y]="labelY" [attr.text-anchor]="tick.anchor">{{ tick.label }}</text>
</svg>

